import React from "react";

const Header = () => (
  <header style={{ textAlign: "center", padding: "2rem 0 1rem 0" }}>
    <h1 style={{ fontWeight: 700, fontSize: "2rem", margin: 0 }}>Tom Williams</h1>
    <div style={{ color: "#888", fontSize: "1.2rem", marginTop: 4 }}>University of Bath</div>
  </header>
);

export default Header;
